var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useStaticColors } from '../hooks/use-theme-colors';
import { useComponentPropsFor } from '../context/component-props-context';
var cls = classNames('circle-cross-small');
export var CircleCrossDefaultProps = {
  colors: {
    stroke: 'light',
    fill: 'primary'
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'CircleCross',
  Container: styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var CircleCross = function (props) {
  var _a = useComponentPropsFor(My.NAME, CircleCrossDefaultProps, props),
    className = _a.className,
    colors = _a.colors,
    onClick = _a.onClick;
  var staticColors = useStaticColors(colors);
  return React.createElement("svg", {
    onClick: onClick,
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    className: cls.name(className)
  }, React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "15.5",
    fill: staticColors.fill,
    stroke: staticColors.stroke
  }), React.createElement("path", {
    d: "M13 13L19 19",
    stroke: staticColors.stroke
  }), React.createElement("path", {
    d: "M13 19L19 13",
    stroke: staticColors.stroke
  }));
};
CircleCross.cls = cls;
var templateObject_1, templateObject_2;